/**
 * Spot Hallucinations Lesson
 * Skill Area: Communication
 * Learn to catch AI fabrications before they damage credibility
 */

import type { LessonDefinition } from '../types';
import { SPOT_HALLUCINATIONS_AI_PROMPT, SPOT_HALLUCINATIONS_CONTEXT_SCENARIOS } from '../prompts/spot-hallucinations.prompt';

export const spotHallucinations: LessonDefinition = {
  id: 'spot-hallucinations',
  title: 'Spot AI Hallucinations',
  displayTitle: 'Catch AI Fabrications Before They Spread',
  subTitle: 'Learn to critique and manage AI outputs.',
  persona: 'Lyra',
  skillArea: 'Communication',
  topicId: 'communication-quality',
  topicTitle: 'Communication Quality & Voice',
  topicDescription: 'Verify outputs, keep your voice authentic, and build reusable comms systems.',
  format: 'guided_chat',
  difficulty: 'Beginner',
  estimatedMinutes: 7,
  tags: ['quality', 'verification', 'hallucinations'],
  dailyEligible: true,
  releasedAt: '2025-01-15T00:00:00.000Z',
  route: '/micro/spot-hallucinations',
  storyBeat: 'Learn to catch AI fabrications before they damage your credibility.',
  introPrompt: "AI writes with total confidence—even when it's making things up. One fabricated statistic can tank your credibility. Let's fix that.",
  steps: [
    "Identify where hallucinations could damage your credibility",
    "Learn the three red flags to watch for",
    "Practice spotting hallucinations in realistic examples",
    "Master the verification prompt technique"
  ],
  promptGuidance: 'Choose content type below or type your own.',
  contextScenarios: SPOT_HALLUCINATIONS_CONTEXT_SCENARIOS,
  aiPrompt: SPOT_HALLUCINATIONS_AI_PROMPT,
  inputPlaceholder: "e.g., Donor emails, Grant proposals...",
  quickPrompts: [
    'Donor emails',
    'Grant proposals',
    'Social media posts',
    'Board reports'
  ]
};
